import type { RouteRecordRaw } from 'vue-router'

export const NewsPages = {
  topNews: 'TopNews',
}

export const TopNews: RouteRecordRaw = {
  path: '/news',
  name: NewsPages.topNews,
  component: () => import('@/pages/main/News/NewsPage.vue'),
  meta: { title: 'TopNews', requiresAuth: true },
}
